<template>
    <div class="page">
        <div class="top">
            <div class="left">
                <div>卡号：{{ loginText }}</div>
                <img src="@/assets/home/copy1.png" alt="" class="copy_id" :data-clipboard-text="loginText"
                    @click="copyCode">
            </div>
            <div class="right">
                <img src="@/assets/home/30.png" @click="activeSim()" alt="">
                <img src="@/assets/home/29.png" @click="toOut()" alt="">
            </div>
        </div>
        <div class="user">
            <img src="./../../assets/all.png" alt="" />
            <!-- <img v-if="simInfo.flowRatePool == '联通' || simInfo.flowRatePool == '乐语'" src="./../../assets/cucc.png" alt="" />
            <img v-else-if="simInfo.flowRatePool == '电信'" src="./../../assets/ctcc.png" alt="" />
            <img v-else-if="simInfo.flowRatePool == '移动' || simInfo.flowRatePool == '移动接口'" src="./../../assets/cmcc.png"
                alt="" />
            <img v-else :src="wxHeadImg" alt="" /> -->
            <div class="time">到期时间：{{ simInfo.endTime }}</div>
            <div class="time">卡状态：{{ simInfo.cardStateName }}</div>
        </div>
        <div class="liuliang">
            <div class="total">
                <div class="num">{{ fluxMtoG(simInfo.flowRate) }}G</div>
                <div class="all">总流量</div>
            </div>
            <div class="total">
                <div class="num">{{ fluxMtoG(simInfo.flowRate - simInfo.usedFlowRate) }}G</div>
                <div class="all">剩余流量</div>
            </div>
            <div class="total">
                <div class="num">{{ fluxMtoG(simInfo.usedFlowRate) }}G</div>
                <div class="all">使用流量</div>
            </div>
        </div>
        <div class="senging">
            <div class="senng" @click="toRecharge()">
                <img src="@/assets/home/39.png" alt="">
                <div class="name">流量充值</div>
            </div>
            <div class="senng" @click="toSupplierAuth()">
                <img src="@/assets/home/44.png" alt="">
                <div class="name">实名认证</div>
            </div>
            <div class="senng" @click="pkgListVisible = true">
                <img src="@/assets/home/40.png" alt="">
                <div class="name">流量查询</div>
            </div>
            <div class="senng" @click="toLogo()">
                <img src="@/assets/home/41.png" alt="">
                <div class="name">充值记录</div>
            </div>
            <div class="senng" @click="tokefu()">
                <img src="@/assets/home/42.png" alt="">
                <div class="name">联系客服</div>
            </div>
            <div class="senng" @click="toShangecheng()">
                <img src="@/assets/home/43.png" alt="">
                <div class="name">卡板商城</div>
            </div>
        </div>

        <div class="el-model">
            <div class="model-items" @click="activeSim()">
                <img src="@/assets/home/32.png" alt="">
                <div class="model-name">自动解锁</div>
            </div>
            <div class="model-items" @click="isTitle = true">
                <img src="@/assets/home/33.png" alt="">
                <div class="model-name">成为代理</div>
            </div>
            <div class="model-items" @click="toAutu()">
                <img src="@/assets/home/37.png" alt="">
                <div class="model-name">自动续费</div>
            </div>
            <div class="model-items" @click="toInvent()">
                <img src="@/assets/home/36.png" alt="">
                <div class="model-name">余额充值</div>
            </div>
            <div class="model-items" @click="gongFlg = true">
                <img src="@/assets/home/40.png" alt="">
                <div class="model-name">关注公众号</div>
            </div>
            <div class="model-items" @click="bindPhone()">
                <img src="@/assets/home/35.png" alt="">
                <div class="model-name">手机绑定</div>
            </div>

            <div class="model-items" @click="activeSim()" v-if="simInfo.supplierName.indexOf('广电') != -1">
                <img src="@/assets/home/32.png" alt="">
                <div class="model-name">一键复机</div>
            </div>
            <div class="model-items" @click="pauseSim()" v-if="simInfo.supplierName.indexOf('广电') != -1">
                <img src="@/assets/home/32.png" alt="">
                <div class="model-name">一件停机</div>
            </div>
        </div>




        <!--  更多套餐信息  -->
        <van-popup v-model="pkgListVisible" closeable position="bottom" style="min-height: 35%; max-height: 75%">
            <div class="pkgList">
                <h3 v-show="simInfo.simPackageList[0]">当前套餐:</h3>
                <h3 v-show="!simInfo.simPackageList[0]" style="color: red">
                    未订购可用套餐
                </h3>
                <ul>
                    <li v-for="item in simInfo.simPackageList" :key="item.id">
                        <p>{{ item.packageName }}</p>
                        <p v-if="item.stateName == '已充值'" style="color: #32c5e9">
                            已充值
                        </p>
                        <p v-else style="color: red">充值中</p>
                        <div>
                            <p>生效时间： {{ item.startTime }}</p>
                            <p v-if="new Date(
                                getDateByTimeStr(item.endTime)[0],
                                getDateByTimeStr(item.endTime)[1],
                                getDateByTimeStr(item.endTime)[2],
                                getDateByTimeStr(item.endTime)[3],
                                getDateByTimeStr(item.endTime)[4],
                                getDateByTimeStr(item.endTime)[5]
                            ) < new Date()
                                " style="color: red">
                                过期时间： {{ item.endTime }}
                            </p>
                            <p v-else>过期时间： {{ item.endTime }}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </van-popup>


        <van-dialog v-model="isTitle" title="温馨提示" confirmButtonColor="#86de6b" confirmButtonText="知道了">
            <img style="width: 100%" src="@/assets/home/daili.jpg">
            <div style="font-size: 14px;color:#999;padding-top:6px;text-align: center;">更多详情，请联系专属销售咨询</div>
        </van-dialog>

        <van-dialog v-model="gongFlg" title="关注公众号" confirmButtonColor="#86de6b" confirmButtonText="知道了">
            <img style="width: 100%" src="@/assets/home/gong.jpg">
            <div style="font-size: 14px;color:#999;padding-top:6px;text-align: center;">更多详情，请关注公众号</div>
        </van-dialog>


    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import Clipboard from "clipboard";
import { wxRequest } from "@/api/user.js";
export default {
    data() {
        return {
            guangdianAuth: false,
            jiaAuth: false,
            gongFlg: false,
            pkgListVisible: false,
            isTitle: false,
            loginText: localStorage.getItem("recordLoginText"),
            simInfo: {
                simId: "",
                simPackageList: [],
                simNextPackageList: [],
                supplierTypeCode: "",
                packageName: null,
                endTime: null,
            },

            cuccAuthShow: false,
            ctccAuthShow: false,
            cmccAuthShow: false,
            qianhaiSHow: false,
            leyuAuthShow: false,
            cmccXxtx: false,
            otherAuth: false,
            otherUrl: '',
            isAuthName: '',
            ctccOldAuth: false,


        }
    },
    mounted() {
        // this.$store.state.iccid = '89860623530060926213';
        // localStorage.setItem("iccid", '89860623530060926213');
        let fd = new FormData();
        fd.append("iccid", localStorage.getItem("iccid"));
        // if(this.$store.state.isHeadquarterAppid=='true'){
        wxRequest("applyChangeSim/isChange", fd, "post").then((res) => {
            if (res.data.code == "200") {
                let cardType = 0;
                let cardTypeStr = "电信";
                if (res.data.data) {
                    cardType = res.data.data.cardType;
                    cardTypeStr =
                        res.data.data.cardType == 0
                            ? "移动"
                            : res.data.data.cardType == 1
                                ? "电信"
                                : "联通";
                }

                //公司本部公众号
                if (localStorage.getItem("isHeadquarterAppid") == "true") {
                    Dialog.alert({
                        title: "提示",
                        messageAlign: "left",
                        message:
                            "尊敬的用户:由于运营商政策影响，造成1898号段广电卡和8986移动无法使用了，现做出以下处理:给您换卡使用，新卡不会出现这种情况，广电新卡为广电Pro，移动新卡为移动pro，套餐给您转移，并且广电的用户这边会赠送您20G通用流量(赠送流量过期时间为11月30日)提交换卡后24小时内发货，京东快递1-3天到货",
                    }).then((action) => {
                        this.$router.push({
                            name: "userChgCard",
                            query: {
                                oldIccid: localStorage.getItem("iccid"),
                                changeCmccSim: cardType,
                            },
                        });
                    });
                } else {
                    Dialog.alert({
                        title: "提示",
                        messageAlign: "left",
                        message:
                            "尊敬的用户：\n&#12288;&#12288;由于运营商系统故障，此卡已暂停使用，请联系您的经销商，谢谢！",
                    });
                }
            }
        })
        this.getUserSimInfo();


    },
    methods: {
        bindPhone() {
            this.$router.replace("/user/bindPhoneList");
        },
        toOut() {
            window.location.href = 'http://vx.iot688.cn/#/user/loginTwo';
        },
        getDateByTimeStr(timeStr) {
            if (timeStr && typeof timeStr === "string") {
                let dayStr = timeStr.split(" ")[0].split("-");
                let hourStr = timeStr.split(" ")[1].split(":");
                return dayStr.concat(hourStr);
            }
            return timeStr;
        },
        submitFeedback() {
            this.$router.push({
                path: "/user/entrance",
                query: {
                    iccid: this.$store.state.iccid,
                },
            });
        },
        toInvent() {
            this.$router.push({ path: '/user/balanceRecharge', query: { iccid: this.$store.state.iccid } })
        },
        toAutu() {
            this.$router.push({ path: '/user/renew', query: { iccid: this.$store.state.iccid } })
        },
        toShangecheng() {
            window.location.href = 'http://vx.iot688.cn/#/user/liuliangka?agentId=0';
        },
        activeSim() {
            wxRequest("sim/to/active", { iccid: localStorage.getItem("iccid") }, "get").then((res) => {
                Dialog.alert({ message: res.data.message });
            });
        },
        pauseSim() {
            wxRequest("sim/to/pause", { iccid: localStorage.getItem("iccid") }, "get").then((res) => {
                Dialog.alert({ message: res.data.message });
            });
        },
        tokefu() {
            window.location.href = 'https://work.weixin.qq.com/kfid/kfcd007f19d3e018030';
            // Dialog.confirm({
            //     title: "专属客服",
            //     message: "请联系小美或者悦悦",
            //     cancelButtonText: "知道了",
            // }).then(() => {

            // })
        },
        toLogo() {
            this.$router.push({
                path: "/user/balanceRechargeRecord"
            });
        },
        toSupplierAuth() {
            wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem("iccid"), intoNo: this.simInfo.intoNo, }, "post").then((res) => {
                if (res.data.code == 200) {
                    this.isAuthName = "已实名";
                    Toast.fail('已实名，无需重复实名！');
                } else if (res.data.code == 302) {
                    this.isAuthName = "请先购买套餐";
                    Toast.fail('请先购买套餐后，再来进行实名操作！');
                } else {
                    Dialog.confirm({
                        title: "实名提醒",
                        message: "根据工信部要求，当卡完成实名后 才可激活正常使用。请您根据指示前往实名(已实名请忽略)",
                        confirmButtonText: "前往实名",
                        cancelButtonText: "暂不实名",
                    })
                        .then(() => {
                            if (this.cmccXxtx == true) {
                                wxRequest(
                                    "wxAuth/cmcc/auth",
                                    { iccid: this.$store.state.iccid },
                                    "post"
                                ).then((res) => {
                                    if (res.data.code == "200") {
                                        window.location.href = res.data.data;
                                    } else {
                                        Dialog.alert({
                                            title: "提示",
                                            message: res.data.message,
                                        });
                                    }
                                });
                            } else if (this.ctccAuthShow == true) {
                                wxRequest(
                                    "wxAuth/ctcc/to/5G/auth",
                                    { iccid: this.simInfo.iccid },
                                    "post"
                                ).then((res) => {
                                    if (res.data.code == "200") {
                                        window.location.href = res.data.data;
                                    } else {
                                        Dialog.alert({
                                            title: "提示",
                                            message: res.data.message,
                                        });
                                    }
                                });
                            } else if (this.cuccAuthShow == true) {
                                window.location.href = "http://vx.iot688.cn/#/user/cuccAuth";
                            } else if (this.cmccAuthShow == true) {
                                this.$router.push({
                                    path: "/user/cmccAuth",
                                    query: { realNameCard: 1 },
                                });
                            } else if (this.guangdianAuth == true) {
                                this.$router.push('/user/ctccGdAuth');
                            } else if (this.jiaAuth == true) {
                                this.$router.push('/user/bindPhoneAuth');
                            } else if (this.ctccOldAuth == true) {
                                this.$router.push('/user/ctccAuth');
                            }
                            else {
                                window.location.href = this.otherUrl;
                            }
                        })
                        .catch(() => { });
                }
            });
        },
        getUserSimInfo() {
            wxRequest("sim/detail", { iccid: this.$store.state.iccid }, "post").then((res) => {
                if (res.data.code == 200) {
                    this.simInfo = res.data.data;
                    let result = res.data.data;
                    if (result.flowRatePool == "5G电信") {
                        this.ctccAuthShow = true;
                    } else if (result.flowRatePool == "联通") {
                        this.cuccAuthShow = true;
                    } else if (result.flowRatePool == "前海") {
                        this.qianhaiSHow = true;
                    } else if (result.flowRatePool == "移动") {
                        this.cmccAuthShow = true;
                    } else if (result.flowRatePool == "乐语") {
                        this.leyuAuthShow = true;
                    } else if (result.flowRatePool == "移动接口") {
                        this.cmccXxtx = true;
                    } else if (result.flowRatePool == "广电") {
                        this.guangdianAuth = true;
                    } else if (result.flowRatePool == "假实名") {
                        this.jiaAuth = true;
                    } else if (result.flowRatePool == '电信') {
                        this.ctccOldAuth = true;
                    } else {
                        if (result.flowRatePool.indexOf('?') > 0) {
                            this.otherUrl = result.flowRatePool + '&cn=' + localStorage.getItem('recordLoginText');
                        } else {
                            this.otherUrl = result.flowRatePool + "?cn=" + localStorage.getItem('recordLoginText');
                        }
                        this.otherAuth = true;
                    }
                    if (this.simInfo.supplierCode == '1905863320154402816' && this.simInfo.flowRate > 0 && this.simInfo.usedFlowRate <= 0) {
                        wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem("iccid"), intoNo: this.simInfo.intoNo, }, "post").then((res) => {
                            if (res.data.code == 200) {
                                Dialog.confirm({
                                    message: "尊敬的用户，此卡板需要下载对应APP方可正常使用。如已下载 请忽略",
                                    confirmButtonText: "去下载",
                                    cancelButtonText: "取消",
                                }).then(() => {
                                    this.$router.replace('/user/loadApp');
                                }).catch(() => { });
                            }
                        })

                    } else if (this.simInfo.basePkgGroup == '1940252174093119488' && this.simInfo.flowRate > 0 && this.simInfo.usedFlowRate <= 0) {
                        wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem("iccid"), intoNo: this.simInfo.intoNo, }, "post").then((res) => {
                            if (res.data.code == 200) {
                                Dialog.confirm({
                                    message: "尊敬的用户，此卡板需要下载对应APP方可正常使用。如已下载 请忽略",
                                    confirmButtonText: "去下载",
                                    cancelButtonText: "取消",
                                }).then(() => {
                                    this.$router.replace('/user/loadApp1');
                                }).catch(() => { });
                            }
                        })

                    }
                }
            }
            );
        },


        toRecharge() {
            this.$router.push({
                path: "/user/recharge",
                query: {
                    iccid: this.$store.state.iccid,
                },
            });
        },
        copyCode() {
            var clipboard = new Clipboard('.copy_id')
            clipboard.on('success', e => {
                Toast.fail('复制成功');
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                Toast.fail('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        }
    }
}
</script>
<style lang="less" scoped>
.page {
    height: 100%;
    background: #EAF3FA url('~@/assets/home/2-bg.png') no-repeat top center;
    background-size: 100% 100%;
    padding: 0 13px;

    .top {
        padding-top: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
            display: flex;
            font-family: PingFangSC, PingFang SC;
            font-size: 14px;
            font-weight: 400;
            align-items: center;

            img {
                width: 18px;
                height: 18px;
                margin-left: 9px;
                cursor: pointer;
            }
        }

        .right {
            display: flex;
            justify-content: flex-end;

            img {
                width: 26px;
                height: 26px;
                cursor: pointer;
                margin-left: 8px;
            }
        }
    }

    .user {
        margin-top: 20px;
        text-align: center;

        img {
            width: 74px;
            height: 74px;
            margin-bottom: 14px;
            border-radius: 100%;
        }

        time {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #030F10;
            line-height: 20px;
        }
    }

    .pkgList {
        padding: 10px 20px;

        h3 {
            margin-top: 20px;
            font-size: 14px;
            line-height: 28px;
            font-weight: bold;
        }

        ul {
            line-height: 38px;

            li {
                display: flex;
                justify-content: space-between;
                margin-bottom: 15px;

                >p {
                    display: flex;
                    align-items: center;
                }

                >div {
                    p {
                        line-height: 18px;
                        font-size: 12px;
                    }
                }
            }
        }
    }

    .liuliang {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 30px;

        .total {
            height: 72px;
            background: #fff;
            border-radius: 12px;
            width: 30%;
            text-align: center;
        }

        .num {
            color: #060606;
            font-size: 18px;
            font-family: HarmonyOS_Sans_SC_Bold;
            margin: 6px 0;
            margin-top: 14px;
            font-weight: bold;
        }

        .all {
            color: #828282;
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            line-height: 20px;
        }
    }

    .senging {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 12px;
        background: #fff;
        border-radius: 12px;
        padding: 15px;
        flex-wrap: wrap;

        .senng {
            width: 30%;
            text-align: center;
            cursor: pointer;
            margin-bottom: 13px;

            img {
                width: 40px;
                height: 36px;
            }

            .name {
                color: #060606;
                font-family: PingFangSC, PingFang SC;
                font-size: 14px;
                margin-top: 10px;
            }
        }
    }

    .el-model {
        margin-top: 14px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;

        .model-items {
            height: 77px;
            background: #fff;
            border-radius: 12px;
            width: 42%;
            padding-left: 18px;
            margin-bottom: 10px;
            display: flex;
            align-items: center;

            img {
                width: 41px;
                height: 39px;
                margin-right: 10px;
            }

            .model-name {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #060606;
            }
        }
    }
}
</style>